import { forwardRef } from 'react'
import { ButtonWithIcon }  from './ButtonWithIcon'
import { TbBrandZoom } from 'react-icons/tb'

export const LoomVideoButton = forwardRef((props, ref) => {
  return <ButtonWithIcon icon={TbBrandZoom} {...props} ref={ref} />
})
